// --- smooth scroll --------------
// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true,   // Smooth wheel behavior
  smoothTouch: false,  // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains('scroll-section')
});

// Update ScrollTrigger on Lenis scroll
lenis.on('scroll', ScrollTrigger.update);

// Integrate Lenis's request animation frame with GSAP's ticker
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

// Disable GSAP's lag smoothing to match Lenis
gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------




// ----------------------- header menu open close -------------
document.querySelector('.header-menu a').addEventListener('click', function(e) {
    e.preventDefault(); 
    
    const label = this.querySelector('.label-menu');
    const spans = this.querySelectorAll('.line-box span');
    const menuDataBox = document.querySelector('.header-menu-data-box');

    if (label.textContent === 'MENU') {
        label.textContent = 'CLOSE';
        spans[0].style.transform = 'rotate(45deg) translate(4px, 4px)';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
        spans[1].classList.add('hidden_spn');
        menuDataBox.classList.add('active'); // Show menu data box
    } else {
        label.textContent = 'MENU';
        spans[0].style.transform = 'none';
        spans[2].style.transform = 'none';
        spans[1].classList.remove('hidden_spn');
        menuDataBox.classList.remove('active'); // Hide menu data box
    }
});
// ----------------------- header menu open close -------------




// ------------------- navbar transparent on hero-section-------------

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header-bre');
  const heroSection = document.querySelector('.hero_section_bre');

  if (heroSection) {
    // Function to handle scroll and update the header background
    const handleScroll = () => {
      const heroSectionTop = heroSection.getBoundingClientRect().top;

      // When the top of the page is reached (header is at the top of the hero section)
      if (window.scrollY === 0) {
        header.classList.add('transparent'); // Transparent at the top
        header.classList.remove('scrolled'); // Remove white background
      } else {
        header.classList.remove('transparent'); // Remove transparent class when scrolling
        header.classList.add('scrolled'); // Add white background when scrolling
      }
    };

    // Run the function initially to set background correctly on page load
    handleScroll();

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);
  } else {
    // If there's no hero section, make the header white by default
    header.classList.remove('transparent');
    header.classList.add('scrolled');
  }
});


// ------------------- navbar transparent on hero-section-------------



// ----------------- size chart -=----------------
// function openSizeBox() {
//     document.querySelector(".size-box").classList.toggle("size-box-active");
// }

// Function to show the appropriate table and activate the size box
function showTable(table) {
    const upperTable = document.getElementById('upper-table');
    const lowerTable = document.getElementById('lower-table');
    const sizeBox = document.querySelector('.size-box'); // Select the size box element

    // Hide both tables first
    upperTable.classList.remove('show');
    lowerTable.classList.remove('show');

    // Show the requested table
    if (table === 'upper') {
        upperTable.classList.add('show');
    } else if (table === 'lower') {
        lowerTable.classList.add('show');
    }

    // Activate the size box when a button is clicked
    sizeBox.classList.add('size-box-active');
}

// Open the size box (this is triggered by the "Upper" and "Lower" buttons)
function openSizeBox() {
    document.querySelector(".size-box").classList.toggle("size-box-active");
}

// Ensure the upper table is shown by default when the page loads
document.addEventListener('DOMContentLoaded', function() {
    showTable('upper');  // Show the upper table by default
    openSizeBox();        // Activate the size box when the page is ready
});

// Add event listeners to the buttons
document.getElementById('upper-btn').addEventListener('click', function() {
    showTable('upper');  // Show the upper table when the "Upper" button is clicked
    openSizeBox();       // Make sure to toggle the size box active when a button is clicked
});

document.getElementById('lower-btn').addEventListener('click', function() {
    showTable('lower');  // Show the lower table when the "Lower" button is clicked
    openSizeBox();       // Make sure to toggle the size box active when a button is clicked
});



// ----------------- size chart -=----------------



// ------------ mobile view buy button hidding -----
const pc = document.querySelector('.m-product-container');
const rp = document.querySelector('.related-products');
const footer = document.querySelector('.footer_section_bre');

const handleScroll = () => {
    if (window.innerWidth <= 768) {
        if (pc && rp) {
            const isVisible = pc.getBoundingClientRect().bottom > rp.getBoundingClientRect().top &&
                              pc.getBoundingClientRect().top < rp.getBoundingClientRect().bottom;
            pc.classList.toggle('fade-out', isVisible);
        }
        if (footer) {
            footer.classList.toggle('fade-out', pc && (pc.getBoundingClientRect().bottom > rp.getBoundingClientRect().top &&
                                                        pc.getBoundingClientRect().top < rp.getBoundingClientRect().bottom));
        }
    } else {
        if (pc) pc.classList.remove('fade-out');
        if (footer) footer.classList.remove('fade-out');
    }
};

window.addEventListener('scroll', handleScroll);



// ------------ mobile view buy button hidding -----




// --------- active p-count button in header -------

document.addEventListener('DOMContentLoaded', function () {
    // Get the current path
    const currentPath = window.location.pathname;

    // Function to reset all p_count backgrounds to the default color (#0003)
    function resetBackgrounds() {
        document.querySelectorAll('.p_count').forEach(pCount => {
            pCount.style.backgroundColor = '#0003'; // Default background color
        });
    }

    // Check if we are on the index page or a product page
    if (
        currentPath === '/' || 
        currentPath === '/index.html' || 
        currentPath.startsWith('/products/')
    ) {
        resetBackgrounds(); // Reset all backgrounds to default on index or product pages
        localStorage.removeItem('clickedCollection'); // Clear localStorage to avoid confusion
    }

    // Check if a collection was clicked previously (using localStorage)
    const clickedCollection = localStorage.getItem('clickedCollection');

    // If we're not on the index or product pages, check for previously clicked collection
    if (
        clickedCollection && 
        !currentPath.startsWith('/products/') && 
        currentPath !== '/' && 
        currentPath !== '/index.html'
    ) {
        const clickedItem = document.querySelector(`.collection_nm a[href="${clickedCollection}"]`);
        if (clickedItem) {
            const pCount = clickedItem.querySelector('.p_count');
            if (pCount) {
                pCount.style.backgroundColor = '#000'; // Set background to black on collection pages
            }
        }
    }

    // Select all collection items
    const collectionItems = document.querySelectorAll('.collection_nm a');

    // Loop through each collection item and add a click event listener
    collectionItems.forEach(item => {
        item.addEventListener('click', function () {
            // Reset all p_count backgrounds to the default color
            resetBackgrounds();

            // Change the background of the clicked p_count to black (#000)
            const pCount = item.querySelector('.p_count');
            if (pCount) {
                pCount.style.backgroundColor = '#000'; // Change the background to black
            }

            // Store the clicked collection URL in localStorage to persist the state
            localStorage.setItem('clickedCollection', item.getAttribute('href'));

            // Redirect to the clicked collection's page
            window.location.href = item.getAttribute('href'); // Navigate to the clicked collection page
        });
    });
});

// --------- active p-count button in header -------


// ------------- desktop product page variant picker click ---------

                  //  document.addEventListener('DOMContentLoaded', function() {
                  //   // Select all elements whose ID contains '18559117721842'
                  //   var refreshButtons = document.querySelectorAll('.refreshme');
                  
                  //   refreshButtons.forEach(function(button) {
                  //     button.addEventListener('click', function() {
                  //       // Add a delay of 2 seconds (2000 milliseconds) before refreshing the page
                  //       setTimeout(function() {
                  //         // Reload the current page (using the current URL)
                  //         location.href = location.href; // This ensures the current URL is reloaded
                  //       }, 1000); // Delay time in milliseconds (2000ms = 2 seconds)
                  //     });
                  //   });
                  // });

// ------------- desktop product page variant picker click ---------





// --------- for collection page img loop ---working------

// // Check for mobile view and duplicate images only for mobile view
// window.addEventListener('resize', handleMobileView);
// window.addEventListener('load', handleMobileView);

// function handleMobileView() {
//     const container = document.querySelector('.custom_collection_image_div');
//     const images = container.querySelectorAll('.ccimage');
    
//     // Only apply for mobile view
//     if (window.innerWidth <= 950) {
//         // Duplicate images only if not already duplicated
//         if (container.querySelectorAll('.duplicated').length === 0) {
//             images.forEach(image => {
//                 const clone = image.cloneNode(true);
//                 clone.classList.add('duplicated');
//                 container.appendChild(clone);
//             });
//         }

//         applyCenterMode(); // Apply the centering effect
//     } else {
//         // Remove duplicates on desktop view
//         container.querySelectorAll('.duplicated').forEach(duplicate => {
//             duplicate.remove();
//         });
//     }
// }

// // Apply the centering effect for mobile view
// function applyCenterMode() {
//     const container = document.querySelector('.custom_collection_image_div');
//     const images = container.querySelectorAll('.ccimage');
    
//     container.scrollLeft = container.scrollWidth / 3; // Initial scroll to center

//     container.addEventListener('scroll', () => {
//         const centerIndex = Math.round(container.scrollLeft / (container.scrollWidth / images.length));
//         images.forEach((image, index) => {
//             const offset = Math.abs(centerIndex - index);
//             if (offset === 0) {
//                 image.style.transform = "scale(1)";
//             } else if (offset === 1) {
//                 image.style.transform = "scale(1)";
//             } else {
//                 image.style.transform = "scale(1)";
//             }
//         });
//     });
// }
// --------- for collection page img loop ----working-----


// --------- for collection page img loop ---try2------

// Check for mobile view and duplicate images only for mobile view
window.addEventListener('resize', handleMobileView);
window.addEventListener('load', handleMobileView);

function handleMobileView() {
    const container = document.querySelector('.custom_collection_image_div');
    const images = container.querySelectorAll('.ccimage');

    // Only apply for mobile view
    if (window.innerWidth <= 950) {
        // Duplicate images only if not already duplicated
        if (container.querySelectorAll('.duplicated').length === 0) {
            images.forEach(image => {
                const clone = image.cloneNode(true);
                clone.classList.add('duplicated');
                container.appendChild(clone);
            });
        }

        applyCenterMode(); // Apply the centering effect
    } else {
        // Remove duplicates on desktop view
        container.querySelectorAll('.duplicated').forEach(duplicate => {
            duplicate.remove();
        });
    }
}

// Apply the centering effect for mobile view
function applyCenterMode() {
    const container = document.querySelector('.custom_collection_image_div');
    const images = container.querySelectorAll('.ccimage');

    if (images.length > 0) {
        const imageWidth = images[0].offsetWidth + parseInt(getComputedStyle(images[0]).marginRight || 0);
        const centerScrollPosition = imageWidth; // Scroll position to center on the second image

        // Disable scroll-snap for the initial scroll
        container.style.scrollSnapType = 'none';
        container.style.scrollBehavior = 'auto'; // Instant scroll

        // Instantly move to the position (second image)
        container.scrollLeft = centerScrollPosition;

        // Re-enable scroll-snap after scroll
        setTimeout(() => {
            container.style.scrollSnapType = 'x mandatory';
            container.style.scrollBehavior = 'smooth';
        }, 50); // Re-enable snap after a very short delay
    }

    // Handle smooth centering during scrolling (if user scrolls)
    container.addEventListener('scroll', () => {
        const centerIndex = Math.round(container.scrollLeft / (container.scrollWidth / images.length));
        images.forEach((image, index) => {
            const offset = Math.abs(centerIndex - index);
            if (offset === 0) {
                image.style.transform = "scale(1)";
            } else if (offset === 1) {
                image.style.transform = "scale(1)";
            } else {
                image.style.transform = "scale(1)";
            }
        });
    });
}

// --------- for collection page img loop ---try2------


//-----------------------------------------dev-3------------------------------------







